module.exports = __webpack_public_path__ + "img/jewellery@2x.213e5b1.png";